<template>
  <div>

    <vx-card>

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="مقالات آکام" icon-pack="feather" icon="icon-check">
            <div class="tab-text">
              <ManageArticles class="mt-4" />
            </div>
          </vs-tab>
          <vs-tab label="کاتالوگ محصولات" icon-pack="feather" icon="icon-check">
            <div class="tab-text">
              <ManageCatalogs class="mt-4" />
            </div>
          </vs-tab>
          <vs-tab label="آکام مدیا" icon-pack="feather" icon="icon-check">
            <div class="tab-text">
              <ManageMedia class="mt-4" />
            </div>
          </vs-tab>
          <vs-tab label="آکادمی آکام" icon-pack="feather" icon="icon-check">
            <div class="tab-text">
              <ManageAcademies class="mt-4" />
            </div>
          </vs-tab>
          <vs-tab label="اطلاعات تماس" icon-pack="feather" icon="icon-check">
            <div class="tab-text">
              <ManageContactUs class="mt-4" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import ManageArticles from "./manageArticles/Show.vue"
import ManageCatalogs from "./manageCatalogs/Show.vue"
import ManageMedia from "./manageMedia/Show.vue"
import ManageAcademies from "./manageAcademies/Show.vue"
import ManageContactUs from "./manageContactUs/Show.vue"

export default {
  components: {
    ManageArticles,
    ManageCatalogs,
    ManageMedia,
    ManageAcademies,
    ManageContactUs,
  },
  data() {
    return {
      activeTab: 0,
    }
  },
  watch: {
  },

  methods: {
  },

  created() {
  }
}

</script>
